import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'

// Raw floating IPs grouped by the port they're attached to ({ [portId]: floatingIp[] }).
// Kept in its own module with no imports from networks/selectors or floating-ips/selectors:
// floating-ips/selectors already imports networks/selectors, so networks/selectors can only
// use this (e.g. in portsSelector) if it lives here without creating a circular import.
export const floatingIpsByPortIdSelector = createSharedSelector(
  getDataSelector<DataKeys.FloatingIps>(DataKeys.FloatingIps),
  (rawFloatingIps) =>
    (rawFloatingIps || []).reduce<Record<string, typeof rawFloatingIps>>((accum, floatingIp) => {
      if (!floatingIp?.port_id) {
        return accum
      }
      if (accum[floatingIp.port_id]) {
        accum[floatingIp.port_id].push(floatingIp)
      } else {
        accum[floatingIp.port_id] = [floatingIp]
      }
      return accum
    }, {}),
)
